import React from 'react';
import { cn } from '../index';

export interface EmptyStateProps {
  icon?: React.ReactNode;
  title: string;
  description?: string;
  action?: React.ReactNode;
  className?: string;
}

export const EmptyState: React.FC<EmptyStateProps> = ({ icon, title, description, action, className }) => (
  <div className={cn('flex flex-col items-center justify-center py-12 px-4 text-center', className)}>
    {icon && <div className="text-[var(--fg-muted)] mb-2.5">{icon}</div>}
    <h3 className="text-sm font-medium text-[var(--fg)]">{title}</h3>
    {description && <p className="text-sm text-[var(--fg-muted)] mt-1 max-w-sm">{description}</p>}
    {action && <div className="mt-3">{action}</div>}
  </div>
);
